import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AccessControlService } from '../services/access-control.service';
import { Observable, of, switchMap } from 'rxjs';

export const accessControlGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const accessService: AccessControlService = inject(AccessControlService);
  const dataPresent = accessService.pageAccessCheck(state.url);
  if (dataPresent) {
    accessService.redirectUrl = accessService.getRedirectUrl(state.url);
    return handleRedirect(accessService, accessService.redirectUrl);
  }
  if (accessService.pageType)
    return accessService.getPageAccess().pipe(
      switchMap((res: any) => {
        accessService.pageAccess$.update(pages => ({ ...pages, [accessService.pageType]: res }));
        accessService.redirectUrl = accessService.getRedirectUrl(state.url);
        return handleRedirect(accessService, accessService.redirectUrl);
      })
    );
  return of(true);
};

function handleRedirect(accessService: AccessControlService, redirectUrl: string): Observable<boolean> {
  if (redirectUrl) {
    accessService.router.navigate([redirectUrl]);
    return of(false);
  }
  return of(true);
}
